






































































































































import CreateDialog from '@/components/CreateDialog.vue'
import Avatar from '@/components/Avatar.vue'
import mixins from 'vue-typed-mixins'
import { crudMixin } from '@/utils/mixins/crudMixin'
import { editMixin } from '@/utils/mixins/editMixin'
import { Client } from '@/api/Agency/agency.interface'
import Autocomplete from '@/components/Autocomplete.vue'
import PhoneTextField from '@/components/PhoneTextField.vue'
import { getSubregions, getRegions, getCountries } from '@/api/Address/address'
import { Params, VueForm } from '@/utils/interfaces'
import { createClient } from '@/api/Agency/agency.api'
import { mask } from 'vue-the-mask'

export default mixins(crudMixin, editMixin).extend({
  components: {
    appCreateDialog: CreateDialog,
    appAvatar: Avatar,
    appAutocomplete: Autocomplete,
    PhoneTextField: PhoneTextField,
  },
  directives: {
    mask,
  },
  data() {
    return {
      clientsType: [
        {
          text: this.$t('ORIGIN'),
          value: 'ORIGIN',
        },
        {
          text: this.$t('DESTINY'),
          value: 'DESTINY',
        },
      ],
      rules: {
        required: (v: string) => !!v || this.$t('validation.field-required'),
      },
      crud: {} as Client,
      defaultCrud: {
        type: 'ORIGIN',
        identity: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '+53',
        address: {
          address_1: '',
          address_2: '',
          country: null,
          region: null,
          subregion: null,
          zip_code: '',
        },
        phone_notify: false,
        email_notify: false,
        image: '',
        credit_card: '',
      } as Client,
      getCountries: getCountries,
      getSubregion: (params?: Params) =>
        getSubregions({
          ...params,
          region: this.$data.crud.address.region,
        }),
      getRegions: (params?: Params) =>
        getRegions({ ...params, country: this.$data.crud.address.country }),
      loading: false,
    }
  },
  methods: {
    async onSuccess() {
      try {
        this.loading = true
        const form = this.$refs.form as VueForm
        if (!form.validate()) return
        const response = await createClient(this.crud)
        this.$emit('new-item', response.data)
        this.$emit('input', false)
        this.resetCrud()
        form.resetValidation()
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    'crud.address.country'() {
      // this.crud.address.region = null;
    },
    'crud.address.region'() {
      // this.crud.address.subregion = null;
    },
  },
})
